import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDatabase = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3327 3.8V8M13.3327 3.8C13.3327 4.79411 10.9449 5.6 7.99935 5.6C5.05383 5.6 2.66602 4.79411 2.66602 3.8M13.3327 3.8C13.3327 2.80589 10.9449 2 7.99935 2C5.05383 2 2.66602 2.80589 2.66602 3.8M13.3327 8V12.0875C13.3327 13.1437 10.9449 14 7.99935 14C5.05383 14 2.66602 13.1437 2.66602 12.0875V8M13.3327 8C13.3327 8.99413 10.9449 9.8 7.99935 9.8C5.05383 9.8 2.66602 8.99413 2.66602 8M2.66602 8V3.8M10.666 7.33333H10.6727M10.666 11.3333H10.6727",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgDatabase);
export default ForwardRef;
